import { IOHelper, utils } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class MapContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.Map;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfArray(this.value, (val) => val[0].size + val[1].size));
    }
    get size() {
        return this.sizeInternal();
    }
    asBoolean() {
        return this.value.length > 0;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeArray(this.value, (parameter) => writer.writeArray(parameter, (value) => value.serializeWireBase(writer)));
    }
    serializeJSON(context) {
        return {
            type: 'Map',
            value: this.value.map((val) => [val[0].serializeJSON(context), val[1].serializeJSON(context)]),
        };
    }
}

//# sourceMappingURL=MapContractParameter.js.map
